

///

import { faClipboardCheck, faCheckCircle, faUserCheck, faUserGraduate, faTimesCircle, faUsers, faUniversity, faPlay } from '@fortawesome/free-solid-svg-icons'
import React, { useEffect } from 'react'
import { Card, Row, Col } from 'react-bootstrap'
import StatsCard from '../../component/Cards/StatsCard'
import StatsCardWithProgress from '../../component/Cards/StatsCardWithProgress'
import DonutChart, { ChartDataItem } from '../../component/Charts/DonutChart'
import { NoDataView } from '../Attendance/VenueWiseReport'
import { ClientService } from '../../component/services/client.service'
import CetLoader from '../../component/Loader/CetLoader'

export default function ReverificationOverviewDev() {

    const [loading, setLoading] = React.useState<boolean>(false);
    const [data, setData] = React.useState<any>(null);
    const [chartData, setChartData] = React.useState<ChartDataItem[]>([]);
    async function getBasicStats() {
        setLoading(true);
        await ClientService.getReverificationStats()
            .then((res: any) => {
                if (res.status === 200) {
                    const statsData = res.data?.data || {};
                    setData(statsData);

                    const newChartData: ChartDataItem[] = [
                        {
                            category: "Success",
                            value: statsData.successCount || 0,
                            fill: "#f47217"
                        },
                        {
                            category: "Failure",
                            value: statsData.failureCount || 0,
                            fill: "#dc3545"
                        }
                    ];
                    setChartData(newChartData);
                } else {
                    console.error("Failed to fetch stats:", res);
                }
            })
            .catch((error: any) => {
                console.error("Error fetching stats:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(() => {
        getBasicStats();
    }, []);
    return (
        <>
            {
                loading ? (
                    <div className="mt-3">
                        <CetLoader />
                    </div>
                ) : (
                    <>
                        <Card
                            className="mt-4 shadow"
                            style={{
                                borderRadius: "16px",
                                border: "1px solid #e9ecef",
                            }}
                        >
                            <Card.Body className="p-4">
                                <h5 className="text-secondary fw-bold mb-4" style={{ fontSize: '18px' }}>
                                    Reverification Overview
                                </h5>

                                <Row>
                                    <Col md={6}>
                                        {chartData.length > 0 && data ? (
                                            <DonutChart
                                                data={chartData}
                                                centerText={{
                                                    label: "Total Verifications",
                                                    value: data?.totalCount || 0
                                                }}
                                                height={400}
                                                width={400}
                                                showTooltip={true}
                                                showLegend={true}
                                                showCalloutLabels={true}
                                            />
                                        ) : (
                                            <NoDataView message="No reverification data available." />
                                        )}
                                    </Col>
                                    <Col md={6}>
                                        {data ? (
                                            <Row className="g-3">
                                                <Col md={12}>
                                                    <StatsCard
                                                        title="Total Verifications"
                                                        value={data?.totalCount || 0}
                                                        icon={faClipboardCheck}
                                                        iconColor="primary"
                                                        valueColor="primary"
                                                    />
                                                </Col>
                                                <Col md={12}>
                                                    <StatsCard
                                                        title="Successful Verifications"
                                                        value={data?.successCount || 0}
                                                        icon={faCheckCircle}
                                                        iconColor="success"
                                                        valueColor="success"
                                                    />
                                                </Col>
                                                <Col md={12}>
                                                    <StatsCardWithProgress
                                                        title="Success Rate"
                                                        value={`${((data?.successCount || 0) / (data?.totalCount || 1) * 100).toFixed(1)}%`}
                                                        progress={(data?.successCount || 0) / (data?.totalCount || 1) * 100}
                                                        icon={faUserCheck}
                                                        iconColor="success"
                                                        valueColor="success"
                                                    />
                                                </Col>
                                            </Row>
                                        ) : (
                                            <NoDataView message="No reverification data available." />
                                        )}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Row className="mt-4 g-3">
                            <Col lg={3} md={6}>
                                <StatsCard
                                    title="Assigned Students"
                                    value={data?.assignedStudents || 0}
                                    icon={faUserGraduate}
                                    iconColor="info"
                                    valueColor="info"
                                />
                            </Col>
                            <Col lg={3} md={6}>
                                <StatsCard
                                    title="Failed Verifications"
                                    value={data?.failureCount || 0}
                                    icon={faTimesCircle}
                                    iconColor="danger"
                                    valueColor="danger"
                                />
                            </Col>
                            <Col lg={3} md={6}>
                                <StatsCard
                                    title="Unique Verifications"
                                    value={data?.uniqueVerifications || 0}
                                    icon={faUsers}
                                    iconColor="warning"
                                    valueColor="warning"
                                />
                            </Col>
                            <Col lg={3} md={6}>
                                <StatsCard
                                    title="Total Colleges"
                                    value={data?.uniqueColleges || 0}
                                    icon={faUniversity}
                                    iconColor="secondary"
                                    valueColor="secondary"
                                />
                            </Col>
                        </Row>

                        <Card className="mt-4 shadow" style={{ borderRadius: "16px", border: "1px solid #e9ecef" }}>
                            <Card.Body className="p-4">
                                <h5 className="text-secondary fw-bold mb-3" style={{ fontSize: '18px' }}>
                                    College Activity
                                </h5>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <StatsCard
                                            title="Started Colleges"
                                            value={data?.startedColleges || 0}
                                            icon={faPlay}
                                            iconColor="success"
                                            valueColor="success"
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <StatsCardWithProgress
                                            title="College Participation Rate"
                                            value={`${((data?.startedColleges || 0) / (data?.uniqueColleges || 1) * 100).toFixed(1)}%`}
                                            progress={(data?.startedColleges || 0) / (data?.uniqueColleges || 1) * 100}
                                            icon={faUniversity}
                                            iconColor="info"
                                            valueColor="info"
                                        />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </>
                )
            }
        </>
    )
}